'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.publishSticky = exports.publish = exports.unsubscribe = exports.subscribe = undefined;

var _pubsubJs = require('pubsub-js');

var _pubsubJs2 = _interopRequireDefault(_pubsubJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A map containing data for topics published in a sticky way. Key is topic name, value is data associated with
 * the topic.
 * @type {StickyEventsDataType}
 */


// types
var stickyEventsData = {};

/**
 * Checks if a given topic has been published in a sticky way.
 * @param {string} topic name of the subscription topic
 * @returns {boolean} true when even has been published in a sticky way, false in an opposite scenario
 */

var isSticky = function isSticky(topic) {
    return Object.prototype.hasOwnProperty.call(
    // not the prettiest, but ES6 Polyfills
    stickyEventsData, topic // make the bundle twice as large and break
    );
}; // in IE [Object.keys().includes]

/**
 * Create or update sticky (re-publishable) data for a given topic name.
 * @param {string} topic name of the subscription topic
 * @param {DataType} data payload to be stored
 * @returns {void}
 */
var upsertStickyData = function upsertStickyData(topic, data) {
    stickyEventsData[topic] = data;
};

/**
 * Invokes handler with a sticky data associated with topic name.
 * The execution is done in a non-blocking way, so that the original request can fully finish first.
 * @param {string} topic name of the subscription topic
 * @param {Function} handler subscriber handler
 * @returns {void}
 */
var queueStickyNotification = function queueStickyNotification(topic, handler) {
    setTimeout(function () {
        handler(topic, stickyEventsData[topic]);
    }, 0);
};

/**
 * Subscribe to specific topic on the message bus.
 * In case the targeted topic has already been published in a sticky way,
 * once the subscription is confirmed by returning a subscription token,
 * the given subscriber will be notified with data last used for specified topic name.
 * @param {string} topic name of the subscription topic
 * @param {Function} handler subscriber handler that will be called when a given topic is published
 * @returns {string} token unique identifier of the subscription that can be used to unsubscribe
 */
var subscribe = exports.subscribe = function subscribe(topic, handler) {
    var token = _pubsubJs2.default.subscribe(topic, handler);

    if (isSticky(topic)) {
        queueStickyNotification(topic, handler);
    }

    return token;
};

var unsubscribe = exports.unsubscribe = function unsubscribe(value) {
    return _pubsubJs2.default.unsubscribe(value);
};

/**
 * Publish specific topic on the message bus.
 * @param {string} topic Name of the subscription topic
 * @param {DataType} data Payload to be carried with the published topic
 * @returns {Boolean} true If any handlers for a given topic found, false in case no action done
 */
var publish = exports.publish = function publish(topic, data) {
    if (isSticky(topic)) {
        upsertStickyData(topic, data);
    }

    return _pubsubJs2.default.publish(topic, data);
};

/**
 * Publish specific topic on the message bus in a sticky way. It means that the last published data will be
 * remembered internally for any subsequent republishing.
 * @param {string} topic name of the subscription topic
 * @param {DataType} data payload to be carried with the published topic
 * @returns {Boolean} true if any handlers for a given topic found, false in case no action done
 */
var publishSticky = exports.publishSticky = function publishSticky(topic, data) {
    upsertStickyData(topic, data);
    return _pubsubJs2.default.publish(topic, data);
};
//# sourceMappingURL=messageBus.js.map